export const STRINGS = {
  LETS_GET_FAMILIAR: "Let’s get familiar",
  TO_GET_STARTED:
    "To get started, simply fill out the registration form below.",
  OR_CONTINUE_WITH: "or continue with email",
  FIRST_NAME: "First Name",
  LAST_NAME: "Last Name",
  EMAIL: "Email",
  SUB_DOMAIN: "Sub-domain",
  PASSWORD: "Password",
  PRIVACY: "Privacy",
  password: "password",
  AND: "and",
  TERMS: "Terms.",
  PLEASE_REGISTER: "Please start again the registration process.",
  ENTER_FIRTNAME: "Enter First Name",
  ENTER_EMAIL: "Enter Email",
  ENTER_LASTNAME: "Enter Last Name",
  CONFIRM_PASSWORD: "Confirm Password",
  INVITATION_TOKEN: "invitation_token",
  URL: "URL",
  ERROR: "error",
  SIGNUP: "Sign up",
  ENTER_PASSWORD: "Enter Password",
  ENTER_CONFIRM_PASSWORD: "Enter Confirm Password",
  ENTER_DOMAIN: "Enter Sub-domain name",
  DEFAULT: "default",
  SIGN_IN_WITH_MICROSOFT: "  Continue with Microsoft",
  SIGN_IN_WITH_GOOGLE: "Continue with Google",
  ALREADY_HAVEAN_ACCOUNT: "Already have an account?",
  SIGN_IN: "Sign In",
};
